module.exports = __webpack_public_path__ + "img/SQUIDPERI-avec-34-584x584.72ecb3ff.webp";